import React, { useState, useEffect } from "react";
import { Row, Col, Space, Table, Button } from "antd";
import API from "../../services/Api";
import BasicLayout, {
    ModuleContent,
    ModuleTool,
} from "../../layouts/basic/BasicLayout";
import style from "./report.module.less";
import moment from "moment";
import Util from "../../services/Util";
import DayColumnChart from "./DayColumnChart";
import BlockTitle from "../../components/BlockTitle";
import DateRangeSelect from "../../components/DateRangeSelect";
import Main from "../share/Main";
import ExportJsonExcel from "js-export-excel";
import { Typography,Tag} from 'antd';

const { Text} = Typography;

const OrderDayReport = () => {

    const [dateRange, setDateRange] = useState([moment().subtract(1, "month"),moment(new Date())]);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
 
    const renderContent = (id, record, idx, children) => {
        let obj = {
            children: children,
            props: {},
        }

        let rowSpans = reportData.filter((item) => (
            item.day == record.day
        )).length;

        obj.props.rowSpan = rowSpans;

        if (idx > 0 && (reportData[idx - 1].day == reportData[idx].day)) {
            obj.props.rowSpan = 0;
        }

        return obj;
    }

    const columns = [
        
        {
            title: "日期",
            dataIndex: "day",
            render: (id, record, idx) => {
                let content = 
                <>
                    <Text strong>{record.day}</Text>                                                      
                </>                            
                return renderContent(id, record, idx, content);
            }
        },
        {
            title: "商户",
            dataIndex: "merchantTitle",
            render: (text, record) => <Text code>{record.merchantTitle}</Text>,
        },
        {
            title: "订单量",
            dataIndex: "num",
            render: (text, record) => <Tag color="#108ee9" >{record.num}</Tag>,
        },
        {
            title: "收入",
            dataIndex: "amount",
            render: (text, record) => (
                <Tag  color="#108ee9" >{Util.currencyFen(text, 2)}</Tag> 
            )
        }
    ];

    const fetch = () => {
        const values = {
            startDate: moment(dateRange[0]).format("YYYY-MM-DD 00:00:00"),
            endDate: moment(dateRange[1]).format("YYYY-MM-DD 23:59:59"),
        };

        API.post("/report/orderReports/query", values).then((res) => {
            setReportData(res.data);
            setLoading(false);
        });
    };

    useEffect(() => {
        fetch();
    }, [dateRange]);

    const dateRangeChange = ([startDate, endDate]) => {
        setDateRange([startDate, endDate]);
    };
    const downloadExcel = () => {
        var option={};
        let dataTable = [];
        if (reportData) {
            for (let i in reportData) {
                let obj = {
                '日期': reportData[i].day,
                '商户': reportData[i].merchantTitle,
                '订单量': reportData[i].num,
                '收入': Util.currencyFen(reportData[i].amount, 2),
                }
                dataTable.push(obj);
            }
        }
        option.fileName = '订单日报表-'+ dataTable[0].日期.slice(0, 7);
        option.datas=[
            {
            sheetData:dataTable,
            sheetName:'订单日报表',
            sheetFilter:['日期','商户','订单量','收入'],
            sheetHeader:['日期','商户','订单量','收入'],
            }
        ];

        var toExcel = new ExportJsonExcel(option); 
        toExcel.saveExcel();
    };


    return (
        <>
            <ModuleTool>
                <Row>
                    <Col flex="1">
                        <span className={style.report_title}>订单日报表</span>
                    </Col>
    
                    <Col flex="600px" className={style.query_area}>
                        <Space>
                            <span>订单日期区间</span>
                            <DateRangeSelect
                            value={dateRange}
                            onChange={dateRangeChange}
                        />
                        </Space>
                    </Col>
                </Row>
            </ModuleTool>
            <ModuleContent>
                {
                      <DayColumnChart
                    title="订单利润趋势图"
                    data={reportData}
                    yField="amount"
                    yAlias="收入"
                  
                    currency={0}
                    type="day"
                />
                }
               {                  
                   <DayColumnChart
                    title="订单量趋势图"
                    data={reportData}
                    yField="num"
                    yAlias="订单量"
                  
                    type="day"
                />
               }
                
    
                <BlockTitle>
                    订单报表
                    <Button type="primary" style={{float:'right', marginRight:'30px'}} onClick={downloadExcel}>导出</Button>
                </BlockTitle>

                <Table
                    dataSource={reportData}
                    size="default"
                    columns={columns}
                    rowKey="id"
                    pagination={false}
                    loading={loading}
                />
            </ModuleContent>
        </>
    );
};



export default OrderDayReport;
